import { usePageTransition } from '../context/TransitionContext';

export default function ShopLayout({
  title,
  subtitle,
  children,
  search,
  onSearch,
  filters,
  activeFilter,
  onFilter,
}) {
  const navigateTo = usePageTransition();

  return (
    <div className="shop-page">
      {/* Header */}
      <header className="shop-header">
        <button className="shop-back" onClick={() => navigateTo('/')} aria-label="Back">
          ← Back
        </button>
        <div className="shop-header__text">
          <p className="shop-header__eyebrow">VODACOM · SHOP</p>
          <h1 className="shop-header__title">{title}</h1>
          {subtitle && <p className="shop-header__sub">{subtitle}</p>}
        </div>
      </header>

      {/* Controls */}
      <div className="shop-controls">
        <div className="shop-search-wrap">
          <span className="shop-search-icon">⌕</span>
          <input
            className="shop-search"
            type="search"
            placeholder="Search deals…"
            value={search}
            onChange={e => onSearch(e.target.value)}
          />
        </div>

        {filters && filters.length > 0 && (
          <div className="shop-filters" role="group" aria-label="Filter">
            {filters.map(f => (
              <button
                key={f}
                className={`shop-chip${activeFilter === f ? ' active' : ''}`}
                onClick={() => onFilter(f)}
              >
                {f}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Grid */}
      <main className="shop-grid">
        {children}
      </main>
    </div>
  );
}
